import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';
import { getMappedChannel } from '../../../utils/utils';
import { Box } from '../../css';

const Outlet = ({ labels, touched, errors, channels, setFieldValue }) => {
  const getChannelRaw = value => {
    const channel = channels.find(i => i.name === value);

    return channel ? [{ id: channel.id, label: channel.description }] : [];
  };

  return (
    <Box>
      <div className="main-content-form-headers">
        <span className="select-placeholder">{labels.OUTLET}*</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.outlet && touched.outlet ? 'error' : ''
        }`}
      >
        <Field
          type="text"
          className="select-style"
          name="outlet"
          onChange={e => {
            const {
              target: { value }
            } = e;
            setFieldValue('outlet', value);
            const channel = getMappedChannel(value);
            if (channel) {
              setFieldValue('channel', getChannelRaw(channel));
            }
          }}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.outlet}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </Box>
  );
};

Outlet.propTypes = {
  labels: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.shape({
    outlet: PropTypes.bool
  }).isRequired,
  errors: PropTypes.shape({
    outlet: PropTypes.string
  }).isRequired,
  channels: PropTypes.arrayOf(PropTypes.object),
  setFieldValue: PropTypes.func.isRequired
};

Outlet.defaultProps = {
  channels: null
};

export default Outlet;
